export default "<div>\n  <input [(ngModel)]=\"value\" (keyup)=\"keyUp($event.target.value)\"  [disabled]=\"disabled\" />\n</div>"